export default __webpack_public_path__ + "static/media/logoutPointIcon.dfd14271.svg";